import { Form } from 'devextreme-react'
import { GroupItem, SimpleItem } from 'devextreme-react/form'
import React, { forwardRef, useState } from 'react'
import { IconList, IconPicker } from '../../components/Iconpicker'
import { ProductFeatures } from './type'

const SelectIcon = forwardRef<any, { data: ProductFeatures }>((
    { data }, ref,
) => {
    const [value, setValue] = useState<any>("");
    return <Form
        ref={ref}
        formData={data}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Icon"}
                render={() => {
                    return <IconPicker
                        value={value}

                        containerStyles={
                            {
                                display: "flex",
                                alignItems: "center",

                                width: "500px",
                                margin: "0px auto",
                                justifyContent: "center",
                                padding: "35px"
                            }
                        }
                        onChange={function (value: IconList): void {
                            setValue(value)
                            data.Icon = value
                        }}>

                    </IconPicker>
                }}
            >

            </SimpleItem>
        </GroupItem>
    </Form>

})
export default SelectIcon